import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import ScheduleList from 'components/Lists/ScheduleList'

import {
  Container
} from './styles'

export default function SchedulesModal ({
  visible,
  schedules,
  onClose: handleClose
}) {
  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='xl' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Agendamentos</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <ScheduleList
              schedules={schedules}
              totalSchedules={schedules.length}
              hasMore={false}
              onScroll={() => null}
              detailed={true}
            />
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
